module.exports = __webpack_public_path__ + "img/h1.26341022.png";